import React, { useEffect } from 'react'
import AddressSearchBox from '../utils/AddressSearch'
import { authStatus, selectAuthUser } from '../auth/AuthSlice'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Typography, Button, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, LinearProgress } from '@mui/material'
import { deleteEstimateCacheAsync, getAllEstimateCacheAsync, selectEstimateCache, selectStatus } from './AdminSlice'
import { Delete, Refresh } from '@mui/icons-material'

const AdminManageCache = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const authUser = useAppSelector(selectAuthUser)
  const loading = useAppSelector(selectStatus)
  const estimateCache = useAppSelector(selectEstimateCache)
  useEffect(() => {
    if (authUser) {
      dispatch(getAllEstimateCacheAsync({ pattern: '' }))
    }
  }, [authUser, dispatch])
  return (
    <Box>
      <Button variant='outlined' onClick={() => dispatch(getAllEstimateCacheAsync({ pattern: '' }))} sx={{ mb: 5 }}><Refresh /> Reload</Button>
      <LinearProgress sx={{ display: loading === 'loading' ? 'block' : 'none' }} />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Key</TableCell>
              <TableCell>&nbsp;</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {estimateCache && estimateCache.map((key) => (
              <TableRow key={key}>
                <TableCell>{key}</TableCell>
                <TableCell>
                  <Button onClick={() => dispatch(deleteEstimateCacheAsync({ key }))}><Delete /> Clear</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default AdminManageCache